import React from 'react';
import TrainingLossPlot from './TrainingLossPlot';
import { useTheme } from '../theme/ThemeContext';

// function getAge(dateString) {
// 	const today = new Date();
// 	const birthDate = new Date(dateString);
// 	let age = today.getFullYear() - birthDate.getFullYear();
// 	const m = today.getMonth() - birthDate.getMonth();
// 	if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
// 		age--;
// 	}
// 	return age;
// }

function About() {
	const { theme } = useTheme();
	const isDark = theme === 'dark';
	//const myAge = getAge('1997-06-19');

	return (
		<section className="about-section section" id="about">
			<div className="container">
				<div className="section-header reveal">
					<span className="section-label">{isDark ? '# 01. ORIGIN' : '01 — About'}</span>
					<h2 className="section-header__title">About</h2>
					<p className="section-header__subtitle">
						Software developer pivoting toward scalable, maintainable systems with applied AI.
					</p>
				</div>

				<div className="about-grid">
					<div className="about-visual reveal reveal-delay-1">
						{/* Wrapper keeps nodes constrained to the SVG dimensions */}
						<div style={{ position: 'relative', width: '100%', margin: '0 auto' }}>
							<svg viewBox="0 0 620 520" style={{ width: '100%', height: 'auto', display: 'block', background: 'var(--bg-elevated, #16161f)', borderRadius: '12px', border: '1px solid rgba(var(--accent-cyan-rgb), 0.1)' }} aria-label="PneumoniaCNN architecture">
								<defs>
									<marker id="arrowCyan" markerWidth="8" markerHeight="6" refX="4" refY="3" orient="auto">
										<polygon points="0,0 8,3 0,6" style={{ fill: 'var(--accent-cyan, #00f0ff)' }} />
									</marker>
									<marker id="arrowPurple" markerWidth="8" markerHeight="6" refX="4" refY="3" orient="auto">
										<polygon points="0,0 8,3 0,6" style={{ fill: 'var(--accent-purple, #7c3aed)' }} />
									</marker>
									<marker id="arrowPink" markerWidth="8" markerHeight="6" refX="4" refY="3" orient="auto">
										<polygon points="0,0 8,3 0,6" style={{ fill: 'var(--accent-pink, #f472b6)' }} />
									</marker>
									<marker id="arrowMuted" markerWidth="8" markerHeight="6" refX="4" refY="3" orient="auto">
										<polygon points="0,0 8,3 0,6" style={{ fill: 'var(--text-muted, #606078)' }} />
									</marker>
								</defs>
								{/* Title */}
								<text x="310" y="30" style={{ fill: 'var(--accent-cyan, #00f0ff)' }} fontFamily="JetBrains Mono, monospace" fontSize="13" fontWeight="bold" textAnchor="middle">PneumoniaCNN — custom PyTorch model</text>
								<text x="310" y="50" style={{ fill: 'var(--text-muted, #606078)' }} fontFamily="JetBrains Mono, monospace" fontSize="10" textAnchor="middle">3 conv blocks · batch norm · dropout · 2-class</text>
								{/* Input */}
								<rect x="210" y="68" width="200" height="30" rx="5" style={{ fill: 'rgba(var(--overlay-rgb), 0.04)', stroke: 'rgba(var(--overlay-rgb), 0.12)' }} strokeWidth="1" />
								<text x="310" y="88" style={{ fill: 'var(--text-primary, #e0e0e8)' }} fontFamily="JetBrains Mono, monospace" fontSize="11" textAnchor="middle">Input: 224×224×3</text>
								{/* Arrow */}
								<line x1="310" y1="98" x2="310" y2="126" style={{ stroke: 'var(--accent-cyan, #00f0ff)' }} strokeWidth="1.5" markerEnd="url(#arrowCyan)" />
								{/* Block 1 */}
								<rect x="135" y="130" width="350" height="28" rx="5" style={{ fill: 'rgba(var(--accent-cyan-rgb), 0.12)', stroke: 'var(--accent-cyan, #00f0ff)' }} strokeWidth="1" />
								<text x="230" y="149" style={{ fill: 'var(--accent-cyan, #00f0ff)' }} fontFamily="JetBrains Mono, monospace" fontSize="11" textAnchor="middle">Conv2d(32)</text>
								<text x="410" y="149" style={{ fill: 'var(--text-secondary, #9898b0)' }} fontFamily="JetBrains Mono, monospace" fontSize="10" textAnchor="middle">BN + ReLU + MaxPool/2</text>
								{/* Arrow */}
								<line x1="310" y1="158" x2="310" y2="186" style={{ stroke: 'var(--accent-purple, #7c3aed)' }} strokeWidth="1.5" markerEnd="url(#arrowPurple)" />
								{/* Block 2 */}
								<rect x="135" y="190" width="350" height="28" rx="5" style={{ fill: 'rgba(var(--accent-purple-rgb), 0.12)', stroke: 'var(--accent-purple, #7c3aed)' }} strokeWidth="1" />
								<text x="230" y="209" style={{ fill: 'var(--accent-purple, #7c3aed)' }} fontFamily="JetBrains Mono, monospace" fontSize="11" textAnchor="middle">Conv2d(64)</text>
								<text x="410" y="209" style={{ fill: 'var(--text-secondary, #9898b0)' }} fontFamily="JetBrains Mono, monospace" fontSize="10" textAnchor="middle">BN + ReLU + MaxPool/2</text>
								{/* Arrow */}
								<line x1="310" y1="218" x2="310" y2="246" style={{ stroke: 'var(--accent-pink, #f472b6)' }} strokeWidth="1.5" markerEnd="url(#arrowPink)" />
								{/* Block 3 */}
								<rect x="135" y="250" width="350" height="28" rx="5" style={{ fill: 'rgba(var(--accent-pink-rgb), 0.12)', stroke: 'var(--accent-pink, #f472b6)' }} strokeWidth="1" />
								<text x="230" y="269" style={{ fill: 'var(--accent-pink, #f472b6)' }} fontFamily="JetBrains Mono, monospace" fontSize="11" textAnchor="middle">Conv2d(128)</text>
								<text x="410" y="269" style={{ fill: 'var(--text-secondary, #9898b0)' }} fontFamily="JetBrains Mono, monospace" fontSize="10" textAnchor="middle">BN + ReLU + MaxPool/2</text>
								{/* Arrow */}
								<line x1="310" y1="278" x2="310" y2="306" style={{ stroke: 'var(--text-muted, #606078)' }} strokeWidth="1.5" markerEnd="url(#arrowMuted)" />
								{/* Feature Map */}
								<rect x="180" y="310" width="260" height="28" rx="5" style={{ fill: 'rgba(var(--overlay-rgb), 0.03)', stroke: 'rgba(var(--overlay-rgb), 0.08)' }} strokeWidth="1" />
								<text x="310" y="329" style={{ fill: 'var(--text-secondary, #9898b0)' }} fontFamily="JetBrains Mono, monospace" fontSize="11" textAnchor="middle">Feature Map: 128×28×28</text>
								{/* Arrow */}
								<line x1="310" y1="338" x2="310" y2="364" style={{ stroke: 'var(--text-muted, #606078)' }} strokeWidth="1.5" markerEnd="url(#arrowMuted)" />
								{/* Flatten label */}
								<text x="310" y="380" style={{ fill: 'var(--text-muted, #606078)' }} fontFamily="JetBrains Mono, monospace" fontSize="10" textAnchor="middle">Flatten</text>
								<line x1="310" y1="386" x2="310" y2="398" style={{ stroke: 'var(--text-muted, #606078)' }} strokeWidth="1" />
								{/* FC1 */}
								<rect x="110" y="402" width="400" height="28" rx="5" style={{ fill: 'rgba(var(--accent-purple-rgb), 0.1)', stroke: 'var(--accent-purple, #7c3aed)' }} strokeWidth="1" />
								<text x="310" y="421" style={{ fill: 'var(--text-primary, #e0e0e8)' }} fontFamily="JetBrains Mono, monospace" fontSize="11" textAnchor="middle">Linear(100,352 → 256) + ReLU + Dropout(0.4)</text>
								{/* Arrow */}
								<line x1="310" y1="430" x2="310" y2="456" style={{ stroke: 'var(--accent-pink, #f472b6)' }} strokeWidth="1.5" markerEnd="url(#arrowPink)" />
								{/* Output */}
								<rect x="155" y="460" width="310" height="30" rx="5" style={{ fill: 'rgba(var(--accent-pink-rgb), 0.1)', stroke: 'var(--accent-pink, #f472b6)' }} strokeWidth="1" />
								<text x="310" y="480" style={{ fill: 'var(--text-primary, #e0e0e8)' }} fontFamily="JetBrains Mono, monospace" fontSize="11" textAnchor="middle">Linear(256 → 2): Normal | Pneumonia</text>
							</svg>
						</div>
						<div style={{ position: 'relative', width: '100%', height: '100%', margin: '0 auto' }}>
							<TrainingLossPlot />
						</div>
					</div>

					<div className="about-text reveal reveal-delay-2">
						<h3>
							Software Engineer{' '}
							<span className="highlight">→</span> Scalable & AI Systems
						</h3>

						<p>
							I left my full-time role in January 2026 to pursue a Bachelor's in
							Software Development, specializing in applied AI and scalable systems.
							After years of shipping production software, I wanted to go deeper —
							understanding the <span className="highlight">architectural trade-offs</span> that
							distinguish systems that scale from those that don't, and bringing ML
							into real-world software with clear, measurable impact.
						</p>

						<p>
							My latest project:{' '}
							<span className="highlight">
								removing non-anatomical artifacts from chest X-rays
							</span>{' '}. This spans computer vision,
							data preprocessing, and model validation — connecting ML research
							techniques to a concrete clinical use case.
						</p>

						<p>
							I'm a Copenhagen-based full-stack engineer who bridges the gap between data systems and business value.
							My work spans ETL pipelines, SaaS automation, and large-scale system integration
							— including connecting hundreds of platforms into cohesive workflows.
							I also have a track record of turning custom client projects into paid product features,
							blending engineering pragmatism with commercial insight.
						</p>
					</div>
				</div>

				<div className="about-metrics reveal reveal-delay-3">
					<div className="about-metric">
						<div className="about-metric__value">4+</div>
						<div className="about-metric__label">Years in Production</div>
					</div>
					<div className="about-metric">
						<div className="about-metric__value">B.Sc.</div>
						<div className="about-metric__label">In Progress (2027)</div>
					</div>
					<div className="about-metric">
						<div className="about-metric__value">3</div>
						<div className="about-metric__label">Domains: SWE · AI · Ops</div>
					</div>
				</div>
			</div>
		</section>
	);
}

export default About;